import React, { useState, useEffect, useRef } from "react";

export const FloatingInput = ({
  id,
  label,
  name,
  type = "text",
  value,
  error,
  touched,
  onChange,
}: {
  id: string;
  label: string;
  name: string;
  type?: string;
  value: string;
  error?: string;
  touched?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  // Check on mount and a short interval to detect autofill
  useEffect(() => {
    const checkAutofill = () => {
      if (inputRef.current?.value && inputRef.current.value.length > 0) {
        setFocused(true);
        clearInterval(intervalId);
      }
    };

    const intervalId = setInterval(checkAutofill, 100);

    // Also check immediately in case value is set on mount
    checkAutofill();

    // Clear interval after 2 seconds to avoid infinite polling
    const timeoutId = setTimeout(() => clearInterval(intervalId), 2000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  const isFloating = focused || (value && value?.length > 0);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        ref={inputRef}
        autoComplete="on"
        onAnimationStart={(e: React.AnimationEvent<HTMLInputElement>) => {
          if (e.animationName === "onAutoFillStart") {
            setFocused(true); // Trigger floating label
          }
        }}
        style={{
          width: "100%",
          padding: "18px 14px 8px 14px",
          borderRadius: "10px",
          border:
            error && touched
              ? "1px solid red" // red if error & touched
              : touched && value // black if touched but input empty
              ? "2px solid #1A1A1A"
              : "1px solid #BFBFBF", // default gray
          fontSize: "15px",
          background: "#fff",
          height: "56px",
        }}
      />
      <label
        htmlFor={id}
        style={{
          position: "absolute",
          left: "14px",
          top: isFloating ? "6px" : "50%",
          fontSize: isFloating ? "12px" : "15px",
          color: error && touched ? "red" : "#999",
          pointerEvents: "none",
          transform: isFloating ? "translateY(0)" : "translateY(-50%)",
          transition: "all 0.2s ease-out",
          backgroundColor: "#fff",
          padding: "0 4px",
        }}
      >
        {label}
      </label>
      {error && touched && (
        <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
          {error}
        </div>
      )}
    </div>
  );
};
